import React from 'react';
import cs from 'classnames';

import SizeWatcher from '~/components/SizeWatcher';
import LoadMap from '~/components/LoadMap';
import css from './index.css';

const LoadMapModal = ({loadId}) => (
  <SizeWatcher className={cs(css.map, 'qa-load-map', `qa-load-${loadId}-map`)}>
    <LoadMap loadId={loadId} allowControlls={true}/>
  </SizeWatcher>
);


export default LoadMapModal;



// WEBPACK FOOTER //
// ./src/components/LoadMapModal/index.js